import classnames from "classnames";

import { FieldRequestForm } from "@krea/customer-features/shared-components/field-request/GetFieldRequestForm";
import { IFieldRequest } from "@krea/customer-features/types/fieldRequest";

import { Text } from "../text";

import PostSelectBidLenderComment from "./PostSelectBidLenderComment";

interface IPostSelectFieldRequestsProps {
  fieldRequests: IFieldRequest[];
}

const PostSelectFieldRequests = ({
  fieldRequests,
}: IPostSelectFieldRequestsProps) => {
  return (
    <>
      {fieldRequests.map((fieldRequest) => (
        <div
          key={fieldRequest.id}
          className={classnames(
            "tw-relative tw-mb-6 tw-w-full tw-rounded-lg tw-border tw-p-6",
            {
              "tw-border-gray-500": !fieldRequest.isSubmitted,
              "tw-border-primary": fieldRequest.isSubmitted,
            },
          )}
        >
          {fieldRequest.displayName && (
            <>
              <div className="tw-mb-4">
                <h5 className="tw-mb-0 tw-pr-2 tw-align-middle">
                  {fieldRequest.displayName}
                </h5>
              </div>
            </>
          )}

          {fieldRequest.lenderComment && (
            <PostSelectBidLenderComment
              comment={fieldRequest.lenderComment}
              className="tw-mb-4"
            />
          )}

          {fieldRequest.subtitle && (
            <Text size="sm" className="tw-mb-4 tw-font-bold">
              {fieldRequest.subtitle}
            </Text>
          )}

          <FieldRequestForm
            fieldRequestID={fieldRequest.id}
            isBidSelected={true}
          />
        </div>
      ))}
    </>
  );
};

export default PostSelectFieldRequests;
